module.exports = __webpack_public_path__ + "img/model_right.dc5549e6.svg";